import { createContext, useContext, type ReactNode } from 'react';

import type { HandshakeState } from '@/handshake/useHandshake.js';

const HandshakeContext = createContext<HandshakeState | null>(null);

export function HandshakeProvider({
  value,
  children,
}: {
  value: HandshakeState;
  children: ReactNode;
}) {
  return <HandshakeContext.Provider value={value}>{children}</HandshakeContext.Provider>;
}

/** Only callable below `HandshakeGate`, where a connected handshake is guaranteed. */
export function useHandshakeContext(): HandshakeState {
  const value = useContext(HandshakeContext);
  if (!value) throw new Error('useHandshakeContext must be used within HandshakeProvider');
  return value;
}
